import { blogsQueryParams } from './blogsQueryParams';
import { newsQueryParams } from './newsQueryParams';

export  const getAuthorBlogsQueryParams = (authorId: string, page: number = 1, pageSize: number = 10) => {
  return {
    ...blogsQueryParams,
    filters: {
      $or: [
        { updated_by_user: { $eq: authorId } },
        { created_by_user: { $eq: authorId } },
      ],
    },
    populate: '*',  // Get all fields including nested relations
    pagination: {
      page,
      pageSize,
    },
  };
};

export const getAuthorNewsQueryParams = (authorId: string, page: number = 1, pageSize: number = 10) => {
  return {
    ...newsQueryParams,
    filters: {
      $or: [
        { updated_by_user: {  $eq: authorId  } },
        { created_by_user: {  $eq: authorId  } },
      ],
    },
    populate: '*',  // Get all fields including nested relations
    pagination: {
      page,
      pageSize,
    },
  };
};
export const createAuthorSlugUrl = (name: string, id: string | number) => {
  if (!name || !id) return null;
  // Remove all spaces and non-alphanumeric characters from name, then append id
  return `/authors/${name.replace(/\s+/g, '').toLowerCase().replace(/[^a-z0-9]/g, '')}${id}`;
};